import { createTheme } from '@mui/material/styles';
import { lightTokens, darkTokens } from './tokens';

const getTheme = (mode) => {
  const tokens = mode === 'dark' ? darkTokens : lightTokens;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: tokens.primaryMain,
      },
      secondary: {
        main: tokens.secondaryMain,
      },
      background: {
        default: tokens.backgroundDefault,
        paper: tokens.backgroundPaper,
      },
      text: {
        primary: tokens.textPrimary,
        secondary: tokens.textSecondary,
      },
      divider: tokens.divider,
      success: {
        main: tokens.successMain,
      },
      error: {
        main: tokens.errorMain,
      },
      warning: {
        main: tokens.warningMain,
      },
    },
    typography: {
      fontFamily: '"Poppins", sans-serif',
    },
    components: {
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 700,
            textTransform: 'none',
          },
          contained: {
            backgroundColor: tokens.btnContainedBg,
            color: tokens.btnContainedText,
            '&:hover': {
              backgroundColor: tokens.btnContainedHover,
            },
          },
          containedPrimary: {
            backgroundColor: tokens.btnContainedBg,
            color: tokens.btnContainedText,
            '&:hover': {
              backgroundColor: tokens.btnContainedHover,
            },
          },
          containedSecondary: {
            backgroundColor: tokens.btnContainedBg,
            color: tokens.btnContainedText,
            '&:hover': {
              backgroundColor: tokens.btnContainedHover,
            },
          },
          outlined: {
            borderColor: tokens.borderStrong,
            color: tokens.primaryMain,
            '&:hover': {
              borderColor: tokens.muted,
              backgroundColor: 'rgba(148,163,184,0.12)',
            },
          },
          outlinedPrimary: {
            borderColor: tokens.borderStrong,
            color: tokens.primaryMain,
          },
          outlinedSecondary: {
            borderColor: tokens.borderStrong,
            color: tokens.primaryMain,
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: tokens.muted,
            '&.Mui-checked': {
              color: tokens.primaryMain,
            },
            '&.MuiCheckbox-indeterminate': {
              color: tokens.primaryMain,
            },
          },
        },
      },
    },
  });
};

export default getTheme;
